"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseUrl = exports.SOCKET_OPEN = exports.SOCKET_MESSAGE = exports.SOCKET_ERROR = exports.SOCKET_CLOSE = void 0;

var _env = require("../env");

// TODO: determine if this works with www?
var baseUrl = function baseUrl() {
  return "wss://".concat((0, _env.getProd)() ? '' : 'test.', "figure.com");
};

exports.baseUrl = baseUrl;
var SOCKET_OPEN = 'SOCKET_OPEN';
exports.SOCKET_OPEN = SOCKET_OPEN;
var SOCKET_MESSAGE = 'SOCKET_MESSAGE';
exports.SOCKET_MESSAGE = SOCKET_MESSAGE;
var SOCKET_CLOSE = 'SOCKET_CLOSE';
exports.SOCKET_CLOSE = SOCKET_CLOSE;
var SOCKET_ERROR = 'SOCKET_ERROR';
exports.SOCKET_ERROR = SOCKET_ERROR;